
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as CreatInfromYwxSOpAmaSMeta } from "/root/app/craft-web/pages/CreatInfrom.vue?macro=true";
import { default as Design_oldiYou7sNKDPMeta } from "/root/app/craft-web/pages/Design_old.vue?macro=true";
import { default as ChildODip5LdNr8BuMeta } from "/root/app/craft-web/pages/design/ChildOD.vue?macro=true";
import { default as ChildOScGBGz4oi3AMeta } from "/root/app/craft-web/pages/design/ChildOS.vue?macro=true";
import { default as designFUrl3ozS0kMeta } from "/root/app/craft-web/pages/design.vue?macro=true";
import { default as indexFrKjSO494WMeta } from "/root/app/craft-web/pages/index.vue?macro=true";
import { default as InfromBErwzjcuHTMeta } from "/root/app/craft-web/pages/Infrom.vue?macro=true";
import { default as loginIiD1qvYeqDMeta } from "/root/app/craft-web/pages/login.vue?macro=true";
import { default as activation_45codeSNaNn3WlGGMeta } from "/root/app/craft-web/pages/manager/activation-code.vue?macro=true";
import { default as hospitalrVlznZDXADMeta } from "/root/app/craft-web/pages/manager/hospital.vue?macro=true";
import { default as user972J2750WqMeta } from "/root/app/craft-web/pages/manager/user.vue?macro=true";
import { default as index9z8hlhe6u3Meta } from "/root/app/craft-web/pages/order/index.vue?macro=true";
import { default as Convertwh7p9v7G7gMeta } from "/root/app/craft-web/pages/param/Convert.vue?macro=true";
import { default as CustomizeoKOHeHx63mMeta } from "/root/app/craft-web/pages/param/Customize.vue?macro=true";
import { default as Fitting3Wlwt6ReS9Meta } from "/root/app/craft-web/pages/param/Fitting.vue?macro=true";
import { default as param0fDERQ0JKHMeta } from "/root/app/craft-web/pages/param.vue?macro=true";
import { default as Patient_old3mXiVmi1VRMeta } from "/root/app/craft-web/pages/Patient_old.vue?macro=true";
import { default as index0tVcI0snlJMeta } from "/root/app/craft-web/pages/patient/[...id]/index.vue?macro=true";
import { default as indexDZ8Nnc2OppMeta } from "/root/app/craft-web/pages/patient/index.vue?macro=true";
import { default as ChildODyDA3nvGo16Meta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/lensDesign/ChildOD.vue?macro=true";
import { default as ChildOSFLz22DfyDGMeta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/lensDesign/ChildOS.vue?macro=true";
import { default as lensDesignDcIUNj9yZZMeta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/lensDesign.vue?macro=true";
import { default as order4fgXlFUu4TMeta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/order.vue?macro=true";
import { default as ConvertKFGjeR6Ul9Meta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/param/Convert.vue?macro=true";
import { default as CustomizeduvaJyyXfOMeta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/param/Customize.vue?macro=true";
import { default as Fitting12ylfAGCeGMeta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/param/Fitting.vue?macro=true";
import { default as paramD6dMWkaW0KMeta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/param.vue?macro=true";
import { default as patientbC25qKUYzvMeta } from "/root/app/craft-web/pages/patientDesign/[...patientDesignId]/patient.vue?macro=true";
import { default as indexZyDcz7qk2vMeta } from "/root/app/craft-web/pages/patientDesign/index.vue?macro=true";
import { default as registerCcBRdskUxLMeta } from "/root/app/craft-web/pages/register.vue?macro=true";
import { default as orderApiJIcnpBkwqtMeta } from "/root/app/craft-web/pages/settings/orderApi.vue?macro=true";
export default [
  {
    name: "CreatInfrom",
    path: "/CreatInfrom",
    meta: CreatInfromYwxSOpAmaSMeta || {},
    component: () => import("/root/app/craft-web/pages/CreatInfrom.vue")
  },
  {
    name: "Design_old",
    path: "/Design_old",
    meta: Design_oldiYou7sNKDPMeta || {},
    component: () => import("/root/app/craft-web/pages/Design_old.vue")
  },
  {
    name: "design",
    path: "/design",
    meta: designFUrl3ozS0kMeta || {},
    component: () => import("/root/app/craft-web/pages/design.vue"),
    children: [
  {
    name: "design-ChildOD",
    path: "ChildOD",
    meta: ChildODip5LdNr8BuMeta || {},
    component: () => import("/root/app/craft-web/pages/design/ChildOD.vue")
  },
  {
    name: "design-ChildOS",
    path: "ChildOS",
    meta: ChildOScGBGz4oi3AMeta || {},
    component: () => import("/root/app/craft-web/pages/design/ChildOS.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/root/app/craft-web/pages/index.vue")
  },
  {
    name: "Infrom",
    path: "/Infrom",
    meta: InfromBErwzjcuHTMeta || {},
    component: () => import("/root/app/craft-web/pages/Infrom.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginIiD1qvYeqDMeta || {},
    component: () => import("/root/app/craft-web/pages/login.vue")
  },
  {
    name: "manager-activation-code",
    path: "/manager/activation-code",
    meta: activation_45codeSNaNn3WlGGMeta || {},
    component: () => import("/root/app/craft-web/pages/manager/activation-code.vue")
  },
  {
    name: "manager-hospital",
    path: "/manager/hospital",
    meta: hospitalrVlznZDXADMeta || {},
    component: () => import("/root/app/craft-web/pages/manager/hospital.vue")
  },
  {
    name: "manager-user",
    path: "/manager/user",
    meta: user972J2750WqMeta || {},
    component: () => import("/root/app/craft-web/pages/manager/user.vue")
  },
  {
    name: "order",
    path: "/order",
    meta: index9z8hlhe6u3Meta || {},
    component: () => import("/root/app/craft-web/pages/order/index.vue")
  },
  {
    name: "param",
    path: "/param",
    meta: param0fDERQ0JKHMeta || {},
    component: () => import("/root/app/craft-web/pages/param.vue"),
    children: [
  {
    name: "param-Convert",
    path: "Convert",
    component: () => import("/root/app/craft-web/pages/param/Convert.vue")
  },
  {
    name: "param-Customize",
    path: "Customize",
    component: () => import("/root/app/craft-web/pages/param/Customize.vue")
  },
  {
    name: "param-Fitting",
    path: "Fitting",
    component: () => import("/root/app/craft-web/pages/param/Fitting.vue")
  }
]
  },
  {
    name: "Patient_old",
    path: "/Patient_old",
    meta: Patient_old3mXiVmi1VRMeta || {},
    component: () => import("/root/app/craft-web/pages/Patient_old.vue")
  },
  {
    name: "patient-id",
    path: "/patient/:id(.*)*",
    meta: index0tVcI0snlJMeta || {},
    component: () => import("/root/app/craft-web/pages/patient/[...id]/index.vue")
  },
  {
    name: "patient",
    path: "/patient",
    meta: indexDZ8Nnc2OppMeta || {},
    component: () => import("/root/app/craft-web/pages/patient/index.vue")
  },
  {
    name: "patientDesign-patientDesignId-lensDesign",
    path: "/patientDesign/:patientDesignId(.*)*/lensDesign",
    meta: lensDesignDcIUNj9yZZMeta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/lensDesign.vue"),
    children: [
  {
    name: "patientDesign-patientDesignId-lensDesign-ChildOD",
    path: "ChildOD",
    meta: ChildODyDA3nvGo16Meta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/lensDesign/ChildOD.vue")
  },
  {
    name: "patientDesign-patientDesignId-lensDesign-ChildOS",
    path: "ChildOS",
    meta: ChildOSFLz22DfyDGMeta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/lensDesign/ChildOS.vue")
  }
]
  },
  {
    name: "patientDesign-patientDesignId-order",
    path: "/patientDesign/:patientDesignId(.*)*/order",
    meta: order4fgXlFUu4TMeta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/order.vue")
  },
  {
    name: "patientDesign-patientDesignId-param",
    path: "/patientDesign/:patientDesignId(.*)*/param",
    meta: paramD6dMWkaW0KMeta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/param.vue"),
    children: [
  {
    name: "patientDesign-patientDesignId-param-Convert",
    path: "Convert",
    meta: ConvertKFGjeR6Ul9Meta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/param/Convert.vue")
  },
  {
    name: "patientDesign-patientDesignId-param-Customize",
    path: "Customize",
    meta: CustomizeduvaJyyXfOMeta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/param/Customize.vue")
  },
  {
    name: "patientDesign-patientDesignId-param-Fitting",
    path: "Fitting",
    meta: Fitting12ylfAGCeGMeta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/param/Fitting.vue")
  }
]
  },
  {
    name: "patientDesign-patientDesignId-patient",
    path: "/patientDesign/:patientDesignId(.*)*/patient",
    meta: patientbC25qKUYzvMeta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/[...patientDesignId]/patient.vue")
  },
  {
    name: "patientDesign",
    path: "/patientDesign",
    meta: indexZyDcz7qk2vMeta || {},
    component: () => import("/root/app/craft-web/pages/patientDesign/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerCcBRdskUxLMeta || {},
    component: () => import("/root/app/craft-web/pages/register.vue")
  },
  {
    name: "settings-orderApi",
    path: "/settings/orderApi",
    meta: orderApiJIcnpBkwqtMeta || {},
    component: () => import("/root/app/craft-web/pages/settings/orderApi.vue")
  }
]